<template lang="pug">
    layout

        // Title
        title-component(
            :title="$t('settings.title')"
            slot="title"
            type="h2"
        )

        navigation(
            slot="navigation"
        )

        div

            // Password change form
            server-setting-form(
                v-if="setting"
                :setting="setting"
                ref="serverSettingFormRef"
            )

</template>

<script>
    import Layout from './Layout.vue';
    import Navigation from './Navigation';
    import ServerSettingForm from './ServerSettingForm.vue';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        components: {
            Layout,
            Navigation,
            ServerSettingForm: ServerSettingForm,
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        created: async function() {
            await this.list();
        },
        computed: {
            ...mapGetters('settings', ['setting', 'settings', 'isLoading'])
        },
        methods: {
            ...mapActions('settings', ['list', 'get', 'update'])
        }
    };
</script>

<style lang="stylus" scoped></style>
